import {
  Button,
  TableCell,
  TableRow,
  Select,
  InputLabel,
  MenuItem,
  Typography,
} from '@mui/material';
import MUIDataTable, {
  MUIDataTableOptions,
  MUIDataTableProps,
} from 'mui-datatables';

import { fetchChallenge, fetchLeaderboardRankings } from 'actions/leaderboard';
import DefaultLayout from 'layouts/default';

import { useContext, useEffect, useState } from 'react';
import './index.css';
import { Link, useParams } from 'react-router-dom';
import Loading from 'components/Loading';
import {
  LeaderboardMergedRankings,
  LeaderboardMeta,
  LeaderboardRankings,
} from 'types/leaderboard';
/* import { getRegistration, RegistrationInfo } from 'actions/challenge'; */
import UserContext from 'contexts/user';
import { Registration } from 'types/user';
import { fetchRegistration } from 'actions/challenge';
import { Box } from '@mui/system';

// const NO_SORT = '__none__';
const ChallengePage = () => {
  const { user } = useContext(UserContext);
  const [registration, setRegistration] = useState<Registration>();
  const [displayMergedRanks] = useState(true);
  const params = useParams<{ id: string }>();
  const [leaderboardRanks, setLeaderboardRanks] = useState<
    LeaderboardRankings | LeaderboardMergedRankings
  >();
  const [leaderboard, setLeaderboard] = useState<LeaderboardMeta>();
  const [leaderboardView, setLeaderboardView] = useState<string>();
  const [dataerr, setdataerr] = useState<string>();

  // const [uniqueSortBy, setUniqueSortBy] = useState(NO_SORT);
  const [offset] = useState(0);
  const [limit] = useState(200);
  const [tags, setTags] = useState<string[]>([]);
  const handleSelectChange = (e: any) => {
    if (e.target.value === 'All') {
      setTags([]);
    } else {
      setTags([e.target.value]);
    }
  };
  const handleLeaderboardViewChange = (e: any) => {
    setLeaderboardView(e.target.value);
  };
  useEffect(() => {
    fetchRegistration(params.id).then((registration) => {
      setRegistration(registration);
    });
    fetchChallenge(params.id).then((leaderboard) => {
      setLeaderboard(leaderboard);
      setLeaderboardView(leaderboard.default_view);
    });
  }, [params.id]);
  useEffect(() => {
    if (leaderboard && leaderboardView) {
      let view = leaderboard.views[leaderboardView];
      fetchLeaderboardRankings(
        params.id,
        offset,
        limit,
        tags,
        displayMergedRanks,
        view.merged_metrics
      )
        .then((data) => {
          setLeaderboardRanks(data);
        })
        .catch((err) => {
          setdataerr(err.message);
        });
    }
  }, [
    leaderboard,
    limit,
    offset,
    params.id,
    tags,
    displayMergedRanks,
    leaderboardView,
  ]);
  if (dataerr) {
    return (
      <DefaultLayout>
        <p>Error: {dataerr}</p>
      </DefaultLayout>
    );
  }

  if (!leaderboard || !leaderboardRanks || !leaderboardView) {
    return (
      <DefaultLayout>
        <Loading text="Loading Challenge" />
      </DefaultLayout>
    );
  }
  // const handleUniqueSortChange: SelectProps['onChange'] = (e) => {
  //   let sortby = e.target.value as string;
  //   setUniqueSortBy(sortby);
  // };

  let columns: string[] = [
    'Submitter',
    'Team',
    'Tags',
    'Submission Name',
    'Submission Date',
  ];
  if (displayMergedRanks) {
    columns = ['Submitter', 'Team', 'Last Submission Date', 'Average'];
  }

  let displayRanks = leaderboardRanks;
  const metricNameToIdx: Record<string, number> = {};
  leaderboard.metrics.forEach((metric, i) => {
    if (displayMergedRanks) {
      if (leaderboard.views[leaderboardView].merged_metrics.indexOf(i) === -1)
        return;
    }
    columns.push(metric);
    metricNameToIdx[metric] = i;
  });
  //@ts-ignore
  const data: MUIDataTableProps['data'] = displayRanks?.entries.map(
    (entry: any) => {
      let tags = 'None';
      if (displayMergedRanks && entry.lastSubmissionDate !== undefined) {
        return [
          entry.username,
          entry.teamName ? entry.teamName : 'None',
          new Date(entry.lastSubmissionDate).toLocaleString(),
          entry.agg ? entry.agg.toFixed(4) : 0,
          ...entry.results,
        ];
      }
      if (entry.tags && tags.length > 0) {
        tags = entry.tags.join(', ');
      }
      return [
        entry.username,
        entry.teamName,
        tags,
        entry.name,
        new Date(entry.submissionDate).toLocaleString(),
        ...entry.results,
      ];
    }
  );
  const options: MUIDataTableOptions = {
    selectableRowsHideCheckboxes: true,
    responsive: 'standard',
    rowsPerPage: 10,
    filter: 'false',
    expandableRows: !displayMergedRanks,
    expandableRowsOnClick: true,
    renderExpandableRow: (rowData: any[], rowMeta: any) => {
      const colSpan = rowData.length + 1;
      //@ts-ignore
      const description = displayRanks.entries[rowMeta.rowIndex].description;
      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            Description: {description ? description : 'No description provided'}
          </TableCell>
        </TableRow>
      );
    },

    // following is for unique sorting
    // customToolbar: () => {
    //   return (
    //     <Toolbar className="tool-bar">
    //       <FormControl variant="filled">
    //         <InputLabel className="sort-label">Unique sort by</InputLabel>
    //         <Select defaultValue={NO_SORT} className="unique-sort" onChange={handleUniqueSortChange}>
    //           <MenuItem value={NO_SORT}>none</MenuItem>
    //           {leaderboard.metrics.map((m) => {
    //             return <MenuItem key={m} value={m}>{m}</MenuItem>
    //           })}
    //         </Select>
    //         {/* <FormHelperText>Unique sort</FormHelperText> */}
    //       </FormControl>
    //     </Toolbar>
    //   );
    // }
    // pagination: false,
  };
  return (
    <DefaultLayout>
      <div className="Challenges">
        <div>
          <Typography variant="h3">{leaderboard.name}</Typography>
          <Typography variant="body1">{leaderboard.description}</Typography>
          {!registration?.teamId && (
            <Button
              className="challenge-action-btn"
              variant="contained"
              color="primary"
              disabled={!registration?.teamId}
            >
              Create/Join a team first to submit
            </Button>
          )}
          {registration?.teamId && leaderboard.settings.submissions && (
            <Link to={`/challenges/${params.id}/submit`}>
              <Button
                className="challenge-action-btn"
                variant="contained"
                color="primary"
                disabled={
                  !registration?.teamId || !leaderboard.settings.submissions
                }
              >
                Create Submission {registration?.teamId && `For Your Team`}
              </Button>
            </Link>
          )}
          {registration?.teamId && !leaderboard.settings.submissions && (
            <Button
              className="challenge-action-btn"
              variant="contained"
              color="primary"
              disabled={
                !registration?.teamId || !leaderboard.settings.submissions
              }
            >
              Submissions are disabled
            </Button>
          )}

          {user?.role === 'admin' && (
            <Link to={`/challenges/${params.id}/admin/submissions`}>
              <Button
                className="challenge-action-btn"
                variant="contained"
                color="primary"
              >
                View All Submissions
              </Button>
            </Link>
          )}
          {user && registration && (
            <Link to={`/challenges/${params.id}/team`}>
              <Button
                className="challenge-action-btn"
                variant="contained"
                color="primary"
              >
                {registration.teamId ? 'Team' : 'Create/Join Team'}
              </Button>
            </Link>
          )}

          {user?.role === 'admin' && (
            <Link to={`/challenges/${params.id}/admin`}>
              <Button
                className="challenge-action-btn"
                variant="contained"
                color="primary"
              >
                Manage
              </Button>
            </Link>
          )}
          <Box>
          <p>Note that the choice of <strong>Track</strong> will show scores below aggregated across the best submissions in that track. All will show the best scores across all submissions.<br/>
          <strong>View</strong> will change which metrics are shown, with Test/Rigid Body and Test/Soft Body corresponding to the evaluation scores used for the respective tracks.<br/>Moreover, some metrics have a /test and /train suffix. These indicate these tasks have a train/test asset split (e.g. TurnFaucet has different faucets used in training and testing). Tasks without /train /test simply use a fixed set of random seeds.</p>
            <Box sx={{ display: 'inline-block', mr: 2 }}>
              <InputLabel id="track-select-label">
                <Typography variant="body2">Track</Typography>
              </InputLabel>
              <Select
                labelId="track-select-label"
                className="repo-selector"
                value={tags.length > 0 ? tags[0] : 'All'}
                onChange={handleSelectChange}
              >
                <MenuItem value={'All'}>All</MenuItem>
                <MenuItem
                  value={'Imitation/Reinforcement Learning (Rigid Body)'}
                >
                  IL/RL (Rigid Body)
                </MenuItem>
                <MenuItem value={'No Restriction (Rigid Body)'}>
                  No Restriction (Rigid Body)
                </MenuItem>
                <MenuItem value={'No Restriction (Soft Body)'}>
                  No Restriction (Soft Body)
                </MenuItem>
              </Select>
            </Box>
            <Box sx={{ display: 'inline-block' }}>
              <InputLabel id="view-select-label">
                <Typography variant="body2">View</Typography>
              </InputLabel>
              <Select
                labelId="view-select-label"
                className="repo-selector"
                value={leaderboardView}
                onChange={handleLeaderboardViewChange}
              >
                {Object.keys(leaderboard.views)
                  .filter(
                    (viewId) =>
                      leaderboard.views[viewId].merged_metrics.length > 0
                  )
                  .map((viewId) => {
                    return (
                      <MenuItem key={viewId} value={viewId}>
                        {viewId}
                      </MenuItem>
                    );
                  })}
              </Select>
            </Box>
          </Box>
        </div>
        <br />
        <div className="data-table-wrapper">
          <MUIDataTable
            data={data}
            columns={columns}
            title="Leaderboard"
            options={options}
          />
        </div>
      </div>
    </DefaultLayout>
  );
};

export default ChallengePage;
